<mat-dialog-content>
    <p *ngIf="data?.message">{{data.message}}</p>
    <div [formGroup]="form" fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field class="w-100">
            <mat-label>{{data.label}}</mat-label>
            <input matInput formControlName="name" (input)="copyPlanExistName($event)">
        </mat-form-field>
        <mat-icon matTooltipClass="sen-snackbar-color" matTooltip="{{translate.getLng('EXISTING_PLAN_NAME_WARNING')}}"
            class="sen-fs16 sen-valign-sub" *ngIf="existingName && checkPlanCopy()" color="invalid">
            warning</mat-icon>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-end mt-4">
    <button type="button" mat-raised-button (click)="closeDialogue(false)">{{translate.getLng('CANCEL')}}</button>
    <button type="button" color="primary" mat-raised-button
        (click)="checkForDisable()">{{data.primary ? data.primary: translate.getLng('COPY')}}</button>
</mat-dialog-actions>